import { useFeatureFlags } from "~/providers/FeatureFlagsProvider";
import { Org } from "~/lib/types";
import { LegacyOrganizationDashboardPage } from "./dashboard-legacy";
import { NewOrganizationDashboardPage } from "./dashboard-new";

interface OrganizationDashboardPageProps {
  org: Org;
}

export function OrganizationDashboardPage({
  org,
}: OrganizationDashboardPageProps) {
  const { isFeatureEnabled } = useFeatureFlags();

  if (isFeatureEnabled("New Org Dashboard")) {
    return <NewOrganizationDashboardPage org={org} />;
  }

  return <LegacyOrganizationDashboardPage org={org} />;
}
